import React from 'react'
import { Link, browserHistory } from 'react-router'
import { __ } from '../lib/helpers'

const propTypes = {
  mode: React.PropTypes.string.isRequired,
  setMode: React.PropTypes.func.isRequired,
}

class Navigation extends React.Component {

  constructor(props) {
    super(props)

    this.handleButtonClick = this.handleButtonClick.bind(this)
  }

  handleButtonClick(event) {
    this.props.setMode(event.target.dataset.mode)
  }

  render() {
    const classLive = (this.props.mode == 'live')
      ? 'Navigation-button Navigation-button--live Navigation-button--active'
      : 'Navigation-button Navigation-button--live'

    const classStories = (this.props.mode == 'stories')
      ? 'Navigation-button Navigation-button--stories Navigation-button--active'
      : 'Navigation-button Navigation-button--stories'

    const classAmbassadors = (this.props.mode == 'ambassadors')
      ? 'Navigation-button Navigation-button--ambassadors Navigation-button--active'
      : 'Navigation-button Navigation-button--ambassadors'


    return (
      <div className="Navigation">

        <button onClick={this.handleButtonClick} data-mode="live" className={classLive}>
          { __('Navigation.live') }
        </button>

        <button onClick={this.handleButtonClick} data-mode="stories" className={classStories}>
          { __('Navigation.stories') }
        </button>

        <button onClick={this.handleButtonClick} data-mode="ambassadors" className={classAmbassadors}>
              {__('Navigation.ambassadors')}
        </button>

      </div>
    )
  }
}

Navigation.propTypes = propTypes

export default Navigation


// WEBPACK FOOTER //
// ./src/components/Navigation.js